// extracted by mini-css-extract-plugin
module.exports = {"termos":"Termos_termos__ARyn2","item":"Termos_item__1hFZF","titulo":"Termos_titulo__kjqkp","texto":"Termos_texto__2mJkC"};